/**
 * Cible courante de la suppression en cascade (super éditeur GTS).
 *
 * En mémoire seulement : la demande n'a de sens que dans l'instant où
 * l'utilisateur vient de se voir refuser une suppression. La persister
 * rouvrirait la modale sur un élément déjà traité au rechargement suivant.
 */
import { create } from "zustand";

import type { DeletionPreview } from "./api";

interface CascadeTarget {
  resource: string;
  id: string;
  preview: DeletionPreview;
}

interface CascadeState {
  target: CascadeTarget | null;
  offer: (target: CascadeTarget) => void;
  dismiss: () => void;
}

export const useCascadeStore = create<CascadeState>((set) => ({
  target: null,
  offer: (target) => set({ target }),
  dismiss: () => set({ target: null }),
}));
